import { render } from "./PermissionForm.vue?vue&type=template&id=3181b22c&scoped=true&ts=true"
import script from "./PermissionForm.vue?vue&type=script&lang=ts"
export * from "./PermissionForm.vue?vue&type=script&lang=ts"

import "./PermissionForm.vue?vue&type=style&index=0&id=3181b22c&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src866133389/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3181b22c"]])

export default __exports__